module.exports = __webpack_public_path__ + "img/snow1.7f9d4ce0.png";